import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useThemeStore } from '../../stores/themeStore';

const HomePage: React.FC = () => {
  const { theme } = useThemeStore();
  const isLight = theme === 'light';
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <section
      id="hero"
      className="relative flex min-h-full flex-col justify-end overflow-hidden pb-[24vh] sm:pb-[26vh] lg:pb-[28vh]"
      style={{ background: 'var(--bg-primary)' }}
    >
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div
          className={`absolute bottom-0 left-1/2 h-[60vh] w-[120vw] -translate-x-1/2 rounded-full blur-[200px] ${
            isLight ? 'bg-emerald-100/40' : 'bg-emerald-500/[0.06]'
          }`}
        />
      </div>

      <div className="relative mx-auto w-full max-w-[1400px] px-6 sm:px-12 lg:px-20">
        <div
          className={`transition-all duration-[1200ms] ease-out ${
            mounted ? 'translate-y-0 opacity-100' : 'translate-y-12 opacity-0'
          }`}
        >
          <div className={`mb-6 flex items-center gap-3 ${isLight ? 'text-stone-400' : 'text-stone-500'}`}>
            <div className={`h-px w-8 ${isLight ? 'bg-stone-300' : 'bg-stone-600'}`} />
            <span className="text-[11px] font-medium uppercase tracking-[0.2em]">AI-Powered Creative Engine</span>
          </div>

          <div className={`mb-5 text-2xl font-black sm:text-4xl ${isLight ? 'text-stone-900' : 'text-white'}`}>
            VideoFlow
          </div>

          <h1
            className={`mb-8 text-6xl font-black leading-[0.9] sm:text-8xl lg:text-9xl ${
              isLight ? 'text-stone-900' : 'text-white'
            }`}
          >
            创意
            <br />
            <span className="bg-gradient-to-r from-emerald-500 via-teal-500 to-cyan-500 bg-clip-text text-transparent">
              一键成真
            </span>
          </h1>

          <Link
            to="/video-projects"
            className={`inline-flex min-h-12 items-center justify-center rounded-lg px-6 text-sm font-semibold text-white transition-colors ${
              isLight
                ? 'bg-primary hover:bg-primary/90'
                : 'border border-primary/30 bg-primary/20 hover:bg-primary/30'
            }`}
          >
            开始创作
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HomePage;
